module.exports = "<input\r\n  #input\r\n  (ngModelChange)=\"onChange($event)\"\r\n  [ngModel]=\"text\"\r\n  class=\"form-control\"\r\n/>\r\n"